import { IconCheckCircle, IconSpinner } from "@tine/designsystem-icons/sharp";
import isNil from "lodash-es/isNil";
import { observer } from "mobx-react-lite";

import { formatDate } from "../common/utils/dateUtils";
import Modal from "../components/Modal";
import loginState from "../stores/auth/loginState";
import cartStore from "../stores/cart/cartStore";
import deliveryDatesStore from "../stores/deliveryDates/deliveryDatesStore";

type IconIndicatorProps = {
   target: number;
   progress: number;
};

const IconIndicator = observer(({ target, progress }: IconIndicatorProps) => {
   if (progress === target) {
      return <IconSpinner className="size-5 animate-spin flex-shrink-0" />;
   }
   if (progress > target) {
      return <IconCheckCircle className="size-5 text-ink-success flex-shrink-0" />;
   }
   return <div className="size-5 flex-shrink-0">&nbsp;</div>;
});

type ProgressLineProps = {
   step: number;
   label: string;
   progress: number;
};

const ProgressLine = observer(({ step, label, progress }: ProgressLineProps) => {
   return (
      <div className="flex items-center gap-1">
         <IconIndicator target={step} progress={progress} />
         <div className="break-words">{label}</div>
      </div>
   );
});

const LoginProgress = () => {
   let assortmentText = "Henter deres produkter og priser";
   if (!isNil(deliveryDatesStore.getCurrentDelivery()) && !isNil(cartStore.orderType)) {
      assortmentText += " for ";
      assortmentText += formatDate(deliveryDatesStore.getCurrentDelivery()?.date, true);
   }

   let progress = 0;
   switch (loginState.currentState) {
      case "VERIFY_SESSION":
         progress = 1;
         break;
      case "LOGGING_IN":
         progress = 2;
         break;
      case "COMPANY_SELECTED":
         progress = 2;
         break;
      case "FEATURES_LOADING":
         progress = 3;
         break;
      case "DELIVERY_DATES_LOADING":
         progress = 4;
         break;
      case "ASSORTMENT_LOADING":
         progress = 4;
         break;
      case "NOTIFICATIONS_LOADING":
         progress = 5;
         break;
   }

   return (
      <Modal
         name="Innloggingsfremdrift"
         isOpen={progress !== 0}
         title="Gjør klar butikken..."
         className="space-y-2"
         size="lg"
         showCloseButton={false}
      >
         <ProgressLine step={1} progress={progress} label="Verifiserer innlogging" />
         <ProgressLine step={2} progress={progress} label="Henter info om kundeforholdet" />
         <ProgressLine step={3} progress={progress} label="Skrur på korrekte ordretyper" />
         <ProgressLine step={4} progress={progress} label={assortmentText} />
         <ProgressLine step={5} progress={progress} label="Henter eventuelle varslinger" />
      </Modal>
   );
};

export default observer(LoginProgress);
